<template>
    <div>
        <div class="title">{{ $t("pay.addHotel") }}</div>
        <div class="mline"></div>
        <div>
            <div class="h_center">
                <!-- <input type="radio" value="1" v-model="isHotel" class="radioclass" /> -->
                <span class="pay-type-item-icon" @click="selectH('1')"><i :class="{active:isHotel==1?true:false}"></i></span>
                <label>{{ $t("hotel.isHotel") }}</label>
                <span style="margin-left:40px" 　class="pay-type-item-icon" @click="selectH('0')"><i :class="{active:isHotel==0?true:false}"></i></span>
                <!-- <input type="radio" value="0" class="radioclass" v-model="isHotel" style="margin-left:150px" /> -->
                <label>{{ $t("hotel.noHotel") }}</label>
            </div>
            <div class="h_main" v-show="isHotel=='1'">
                <div class="title">{{ $t("hotel.selectHotelTitle") }}</div>
                <div class="h_center">
                    <button v-for="hotel in hotels" @click="selectHotel(hotel.hId)" class="ht_name_circle" v-bind:class="{select_circle:hotel.hId==hotelSelected}" v-show="hotel.hFl=='1'">{{hotel.hName}}</button>
                </div>
                <div class="title">{{ $t("hotel.selectHotelTime") }}</div>
                <div class="h_dt" style="margin-top:25px">
                    <label>{{ $t("hotel.inHotelTime") }}</label>
                    <select v-model="start">
                        <option value="">{{ $t("hotel.selectDt") }}</option>
                        <option v-for="dayS in dayRange" :value="dayS.value">{{dayS.text}}</option>
                    </select>
                    <label style="margin-left: 30px">{{ $t("hotel.outHotelTime") }}</label>
                    <select v-model="end">
                        <option value="">{{ $t("hotel.selectDt") }}</option>
                        <option v-for="dayE in dayRange" :value="dayE.value">{{dayE.text}}</option>
                    </select>
                    <label style="margin-left: 30px">{{ $t("hotel.days") }}</label>
                    <input type="text" readonly="readonly" v-model="evening" />
                </div>
                <div class="h_room" style="margin-top:20px" v-if="locale=='ch'">
                    <label>{{ $t("hotel.roomType") }}</label>
                    <button v-for="room in rooms" class="ht_room_circle" @click="selectRoom(room.rmId,room.rmPrice,room.rmBedFl,room.rmRemain,room.rmStartDt,room.rmEndDt,room.rmMaleFl,room.rmFemaleFl,room.rmBedCount)" v-bind:class="{'cant_select':room.rmRemain==0,'select_circle':(roomSelected==room.rmId&&room.rmRemain>0)||(roomSelected==room.rmId&&room.rmRemain==0&&opFlag=='1')}">
                        {{room.rmName}}{{room.rmPrice}}{{locale=='en'?"CNY":"元"}}/{{room.rmBedFl=="0"?(locale=="en"?"person":"间"):(locale=="en"?"person":"间")}}/{{room.rmBedFl=="0"?(locale=="en"?"night":"晚"):(locale=="en"?"night":"晚")}}
                    </button>
                </div>
                <div class="h_room" style="margin-top:20px;clear:both" v-if="locale=='en'">
                    <label style="float:left;height:50px">{{ $t("hotel.roomType") }}</label>
                    <button style="float:left" v-for="room in rooms" class="ht_room_circle_en" @click="selectRoom(room.rmId,room.rmPrice,room.rmBedFl,room.rmRemain,room.rmStartDt,room.rmEndDt,room.rmMaleFl,room.rmFemaleFl,room.rmBedCount)" v-bind:class="{'cant_select':room.rmRemain==0,'select_circle':(roomSelected==room.rmId&&room.rmRemain>0)||(roomSelected==room.rmId&&room.rmRemain==0&&opFlag=='1')}">
                        {{room.rmName}} {{room.rmPrice}} {{locale=='en'?"CNY":"元"}}/{{locale=="en"?"night":"晚"}}
                    </button>
                </div>
                <div style="margin-left:30px;clear:both" v-show="roomFlag!='1'">
                    <div style="margin-top:20px" v-show="showSex">
                        <label :class="{ch_mg_sex:locale=='ch',en_mg_sex:locale=='en'}">{{ $t("hotel.sexType") }}</label>
                        <!-- <input type="radio" value="1" class="radioclass" v-model='male' @click="selectMale('1')"> -->
                        <span class="pay-type-item-icon" @click="selectMale('1')"><i :class="{active:male==1?true:false}"></i></span>
                        <label style="display:inline-block;width:40px">{{ $t("hotel.male") }}</label>
                        <!-- <input type="radio" value="0" class="radioclass" v-model='male' @click="selectMale('0')"> -->
                        <span class="pay-type-item-icon" @click="selectMale('0')"><i :class="{active:male==0?true:false}"></i></span>
                        <label>{{ $t("hotel.female") }}</label>
                    </div>
                    <div style="margin-top:20px;clear:both" v-show="showTogether && regConfig.cfgRoomieFl=='1'">
                        <label :class="{ch_mg_sex:locale=='ch',en_mg_sex:locale=='en'}">{{ $t("hotel.togeType") }}</label>
                        <!-- <input type="radio" value="1" class="radioclass" v-model="isToge"> -->
                        <span class="pay-type-item-icon" @click="selectRoomie('1')"><i :class="{active:isToge==1?true:false}"></i></span>
                        <label style="display:inline-block;width:40px">{{ $t("hotel.yes") }}</label>
                        <!-- <input type="radio" value="0" class="radioclass" v-model="isToge"> -->
                        <span class="pay-type-item-icon" @click="selectRoomie('0')"><i :class="{active:isToge==0?true:false}"></i></span>
                        <label>{{ $t("hotel.no") }}</label>
                    </div>
                    <div style="margin-top:20px;clear:both" class="together" v-show="isToge=='1'">
                        <label :class="{ch_mg_toge:locale=='ch',en_mg_toge:locale=='en'}">{{ $t("hotel.togeName") }}</label>
                        <input type="text" value="" v-model="roomieName" :placeholder='$t("hotel.togeName")' />
                    </div>
                    <div style="margin-top:10px;clear:both" class="together" v-show="isToge=='1'">
                        <label :class="{ch_mg_toge:locale=='ch',en_mg_toge:locale=='en'}">{{ $t("hotel.togePhone") }}</label>
                        <input type="phone" value="" v-model="roomiePhone" maxlength="11" :placeholder='$t("hotel.togePhone")' />
                    </div>
                </div>
                <div class="togeTxt" v-html="hotelDesc">
                </div>
                <div>
                    <div style="text-align:right;margin-right:100px">
                        <span style="font-size:22px;color:#000;font-weight:700">{{ $t("hotel.hotelMoney") }}:</span>
                        <span style="font-size:22px;color:red;font-weight:700">{{money}}{{locale=='en'?"CNY":"元"}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="isHotel=='1'">
            <div class="title">{{ $t("hotel.hotelPayType") }}</div>
            <div class="mline"></div>
            <div class="h_center">
                <span class="pay-type-item-icon" @click="selectPayway('1')" v-if="hotelOnlineFl==1"><i :class="{active:payWay==1?true:false}"></i></span>
                <label v-if="hotelOnlineFl==1" for="radio">{{ $t("pay.payOnline") }}</label>
                <!--  <input type="radio" value="2" class="radioclass" v-model="payWay" v-if="hotelOfflineFl==1 && hotelOnlineFl==1" style="margin-left:150px"> -->
                <span class="pay-type-item-icon" @click="selectPayway('2')" style="margin-left:150px" v-if="hotelOfflineFl==1 && hotelOnlineFl==1"><i :class="{active:payWay==2?true:false}"></i></span>
                <label v-if="hotelOfflineFl==1 && hotelOnlineFl==1">{{ $t("pay.payOffline") }}</label>
                <span class="pay-type-item-icon" @click="selectPayway('2')" style="margin-left:150px" v-if="hotelOfflineFl==1 && hotelOnlineFl==0"><i :class="{active:payWay==2?true:false}"></i></span>
                <label v-if="hotelOfflineFl==1 && hotelOnlineFl==0">{{ $t("pay.payOffline") }}</label>
            </div>
        </div>
        <div class="foot">
            <button class="btn" @click="goPre" v-show="opFlag!='1'&&opFlag!='2'">{{ $t("btn.pre") }}</button>
            <button class="btn" @click="goNext">{{ $t("btn.next") }}</button>
        </div>
    </div>
</template>
<script>
import lang from '@/lang.json'
export default {
    data() {
            return {
                uid: '',
                cid: '',
                info: {},
                bookId: '',
                isHotel: 1,
                regConfig: {},
                hotels: [],
                regId: '',
                defHotel: {}, //默认选中的酒店对象
                hotelSelected: '', //默认酒店ID
                roomSelected: '', //默认房型ID
                dayRange: [], //酒店开始入住时间、退房时间
                rooms: [], //酒店对应的房型
                opFlag: '', //修改过来的标识
                //evening:'',//入住天数
                price_evening: '', //酒店每天单价
                //money: '', //酒店费用
                start: '', //入住时间
                end: '', //退房时间
                roomPrice: '',
                myRmRemain: '',
                rmFemaleFl: '',
                rmMaleFl: '',
                roomFlag: '', //房型标识
                showTogether: false, //是否显示同行人
                male: '2', //性别
                showSex: false, //是否显示选择性别
                isToge: '0', //是否有同行人
                roomieName: '', //同行人姓名
                roomiePhone: '', //同行人手机
                payWay: '1', //支付方式
                errorInfo: '', //校验错误信息
                hotelOnlineFl: '',
                hotelOfflineFl: '',
                hotelBook: {},
                opFlag: '', //修改标识
                hotelDesc: '',
                locale: ''
            }
        },
        mounted() {
            this.locale = localStorage.getItem("locale");
            this.opFlag = this.$route.params.opFlag;
            this.hotelBook = JSON.parse(sessionStorage.getItem("hotelBook"));

            this.uid = JSON.parse(localStorage.getItem('user')).uId;
            this.cid = localStorage.getItem("cid");
            this.info = JSON.parse(sessionStorage.getItem("info"));
            this.regConfig = this.info.reg_config;
            if (sessionStorage.getItem('payInfo') != null) {
                this.regId = JSON.parse(sessionStorage.getItem('payInfo')).data.register.regId;
            } else {
                this.regId = this.info.register.regId;
            }

            this.hotels = this.info.hotels;
            this.hotelSelected = this.regConfig.cfgDefHotel;
            this.roomSelected = this.regConfig.cfgDefRoom;
            this.hotelOnlineFl = this.regConfig.cfgHotelOnlineFl;
            this.hotelOfflineFl = this.regConfig.cfgHotelOfflineFl;

            // if(this.hotelBook==null && this.info.hotel_book!=null){
            //     this.hotelBook = this.info.hotel_book;
            // }
            if (this.opFlag != '2' && this.hotelBook != null) { //如果是从下一个页面返回回来的
                this.hotelSelected = this.hotelBook.bookHid;
                this.roomSelected = this.hotelBook.bookRmid;
                this.start = new Date(this.hotelBook.bookStartDt).Format("yyyy-MM-dd");
                this.end = new Date(this.hotelBook.bookEndDt).Format("yyyy-MM-dd");
                this.roomieName = this.hotelBook.bookRoomieName;
                this.roomiePhone = this.hotelBook.bookRoomiePhone;
                this.payWay = this.hotelBook.bookPayway;
                this.male = this.hotelBook.bookGender;
                this.bookId = this.hotelBook.bookId;
            }

            //把选中的酒店赋予一个酒店对象
            for (var i = 0; i < this.hotels.length; i++) {
                if (this.hotels[i].hId == this.hotelSelected) {
                    this.defHotel = this.hotels[i];
                    break;
                }
            }
            if (this.defHotel.rooms != null) {
                for (var j = 0; j < this.defHotel.rooms.length; j++) {
                    if (this.defHotel.rooms[j].rmId == this.roomSelected) {
                        this.roomPrice = this.defHotel.rooms[j].rmPrice;
                        this.myRmRemain = this.defHotel.rooms[j].rmRemain;
                        this.rmFemaleFl = this.defHotel.rooms[j].rmFemaleFl;
                        this.rmMaleFl = this.defHotel.rooms[j].rmMaleFl;
                        this.rmBedFl = this.defHotel.rooms[j].rmBedFl;
                    }
                }
            }


            this.dayRange = this.defHotel.days;
            this.rooms = this.defHotel.rooms;
            this.hotelDesc = this.defHotel.hDesc;
            if (this.hotelOnlineFl == 1) {
                this.payWay == '1'
            }
            if (this.hotelOnlineFl == 0 && this.hotelOfflineFl == 1) {
                this.payWay = '0';
            }
            if (this.rmBedFl == '1') {
                this.showSex = true;
                this.showTogether = true;
            }
        },
        methods: {
            //选择酒店的点击事件
            selectHotel: function(hId) {
                this.hotelSelected = hId;
                this.roomSelected = "";
                this.roomPrice = "0";
                //把选中的酒店赋予一个酒店对象
                for (var i = 0; i < this.hotels.length; i++) {
                    if (this.hotels[i].hId == this.hotelSelected) {
                        this.defHotel = this.hotels[i];
                        break;
                    }
                }
                this.dayRange = this.defHotel.days;
                this.rooms = this.defHotel.rooms;
                this.hotelDesc = this.defHotel.hDesc;
            },
            //选择房型的点击事件
            selectRoom: function(rmId, rmPrice, rmBedFl, rmRemain, rmStartDt, rmEndDt, rmMaleFl, rmFemaleFl, rmBedCount) {
                if (rmRemain == '0') { //如果房间剩余房间为0，点击则提示
                    this.$Message.warning(this.$t("info.hotelError1"), 3);
                    return false;
                }

                this.roomSelected = rmId;
                this.roomPrice = rmPrice;
                this.rmBedFl = rmBedFl;

                //如果是大床房，就不用显示同行人
                if (rmBedFl == "0" || rmBedFl == "2") {
                    this.showSex = false;
                    this.roomFlag = "1"; //大床房
                    this.showTogether = false;
                    this.male = "3"; //如果是大床房,避开性别校验
                } else if (rmBedFl == "1") { //如果是床位 并且剩余床位大于1 才会显示同行人
                    this.male = "2";
                    this.roomFlag = "0";
                    this.showTogether = true;
                    this.showSex = true;
                    this.rmMaleFl = rmMaleFl; //是否可以预订男性床位
                    this.rmFemaleFl = rmFemaleFl; //是否可以预订女性床位
                }

            },
            //选择性别
            selectMale: function(flag) {
                flag == 1 ? this.male = 1 : this.male = 0;
            },
            //选择同行人
            selectRoomie: function(flag) {
                flag == 1 ? this.isToge = 1 : this.isToge = 0;
            },
            //选择支付方式
            selectPayway: function(flag) {
                flag == 1 ? this.payWay = 1 : this.payWay = 2;
            },
            //选择是否预订酒店
            selectH: function(flag) {
                flag == 1 ? this.isHotel = 1 : this.isHotel = 0;
            },
            validateHotel: function() {
                if (this.hotelSelected == "") {
                    this.errorInfo = this.$t("info.hotelError2");
                    return false;
                }
                if (this.start == "") {
                    this.errorInfo = this.$t("info.hotelError3");
                    return false;
                }
                if (this.end == "") {
                    this.errorInfo = this.$t("info.hotelError4");
                    return false;
                }
                if (this.roomSelected == null || this.roomSelected == "") {
                    this.errorInfo = this.$t("info.hotelError5");
                    return false;
                }
                if (this.male == "2") {
                    this.errorInfo = this.$t("info.hotelError6");
                    return false;
                }
                if (this.male == "1" && this.rmMaleFl == "0" && this.regConfig.cfgRoomidFl == '1') {
                    this.errorInfo = this.$t("info.hotelError7");
                    return false;
                }
                if (this.male == "0" && this.rmFemaleFl == "0" && this.regConfig.cfgRoomidFl == '1') {
                    this.errorInfo = this.$t("info.hotelError7");
                    return false;
                }
                return true;
            },
            goPre: function() {
                this.$router.push('/sign/apply/0');
            },
            goNext: function() {
                if (this.isHotel == '1') {
                    if (this.validateHotel()) {

                        let param = {
                            "bookid": this.bookId,
                            "book_status": (this.opFlag == '1' || this.opFlag == '2') ? "1" : "0",
                            "regid": this.regId,
                            "pay_way": this.payWay,
                            "uid": this.uid,
                            "cid": this.cid,
                            "src": "2",
                            "hotel_id": this.hotelSelected,
                            "room_id": this.roomSelected,
                            "book_start": this.start,
                            "book_end": this.end,
                            "book_days": this.price_evening,
                            "bed_fl": this.rmBedFl,
                            "gender": this.male,
                            "roomie_fl": this.isToge,
                            "roomie_name": this.roomieName,
                            "roomie_phone": this.roomiePhone
                        }
                        this.postHttp('/medapp/api/template/register/hotel/add', param).then((result) => {
                            //console.log(JSON.stringify(result.data));
                            if (result.data.code == '0') {
                                if (this.opFlag == '1' || this.opFlag == '2') {
                                    this.$router.push('/order/info');
                                } else {
                                    sessionStorage.setItem("hotelBook", JSON.stringify(result.data.hotel_book));
                                    if (this.locale == 'ch') {
                                        this.$router.push('/sign/invoice/0');
                                    } else {
                                        this.$router.push('/sign/morder'); //英文跳过发票信息页面
                                    }

                                }

                            } else if (result.data.code == '1235') {
                                this.$Message.error(this.$t("info.hotelError7"), 2);
                            } else if (result.data.code == '1236') {
                                this.$Message.error(this.$t("info.hotelError8"), 2);
                            }
                        });
                    } else {
                        this.$Message.warning(this.errorInfo, 3);
                    }

                } else { //不预定酒店
                    let param = {
                        "uid": this.uid,
                        "cid": this.cid,
                        "type": "1",
                        "bookid": this.bookId,
                        "regid": ""
                    }
                    this.postHttp("/medapp/api/template/register/clean", param).then((result) => {
                        if (result.data.code == '0') {
                            if (this.opFlag == '1' || this.opFlag == '2') {
                                this.$router.push('/order/info');
                            } else {
                                sessionStorage.removeItem("hotelBook");
                                if (this.locale == 'ch') {
                                    this.$router.push('/sign/invoice/0');
                                } else {
                                    this.$router.push('/sign/morder'); //英文跳过发票信息页面
                                }
                            }
                        }
                    })
                }


            }
        },
        computed: {
            evening: function() {
                if (this.start != '' && this.end != '') {
                    this.price_evening = this.getDiffDays(this.start, this.end);
                    return this.price_evening + (this.locale == "en" ? "night" : "晚");
                }

            },
            money: function() {
                var hotelFee = this.roomPrice * this.price_evening;
                var fixHotelFee = parseFloat(hotelFee).toFixed(2);
                return fixHotelFee;
            }
        },
        watch: {
            start: function(newValue, oldValue) {
                if (this.start != '' && this.end != '' && newValue >= this.end) {
                    this.start = '';
                    this.$Message.warning(this.$t("info.hotelError9"), 3);
                }
            },
            end: function(newValue, oldValue) {
                if (this.end != '' && this.start != '' && newValue <= this.start) {
                    this.end = '';
                    this.$Message.warning(this.$t("info.hotelError10"), 3);
                }
            }
        }
}
</script>
<style scoped>
.ch_mg_sex {
    width: 120px;
    display: inline-block
}

.en_mg_sex {
    width: 150px;
    display: inline-block
}

.ch_mg_toge {
    display: inline-block;
    width: 100px
}

.en_mg_toge {
    display: inline-block;
    width: 250px
}

.title {
    font-size: 16px;
    color: #000;
    font-weight: 600;
    margin-top: 20px;
}

.mline {
    height: 1px;
    width: 100%;
    background: #DCDCDC;
    margin-top: 5px;
}

.h_center {
    margin-top: 20px;
    text-align: center;
}

.radioclass {
    height: 20px;
    width: 20px;
    margin: 3px 10px 3px 5px;
    vertical-align: middle;
}

input[type="radio"] {
    background-color: #F39800;
}

.h_center label {
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

.h_main {
    margin-top: 30px;
}

.ht_name_circle {
    width: 390px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-left: 40px;
}


/*模拟单选框begin*/

.pay-type-item-icon {
    font-size: 0;
    border: 1px solid #B5B5B5;
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.pay-type-item-icon i {
    display: inline-block;
    padding: 5px;
    background-color: #FFFFFF;
    border-radius: 50%;
}

.pay-type-item-icon i.active {
    background-color: #F39800;
}


/*模拟单选框end*/


/*椭圆选中状态样式*/

.select_circle {
    background-color: #F39800!important;
    color: #FFF!important;
    border: 0!important;
}

.togeTxt {
    color: #00AAEE;
    padding-top: 30px;
    font-size: 16px;
    clear: both;
}


/*椭圆未被选中样式*/

.cant_select {
    background-color: #EEEEEE!important;
}

label {
    font-size: 16px;
    color: #000;
    margin-right: 10px;
}

.h_dt select {
    height: 30px;
    width: 120px;
    border-radius: 30px;
    outline: none;
    padding-left: 10px;
    font-size: 16px;
    border: 1px solid #cfcfcf;
}

.h_dt input {
    height: 30px;
    width: 120px;
    border-radius: 30px;
    outline: none;
    padding-left: 10px;
    border: 1px solid #cfcfcf;
    font-size: 16px
}

.ht_room_circle {
    width: 210px;
    height: 30px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

.ht_room_circle_en {
    width: 340px;
    height: 30px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 10px;
    margin-bottom: 10px;
}

.ht_room button:nth-child(3n) {
    margin-left: 120px
}

.together input {
    width: 300px;
    height: 35px;
    line-height: 35px;
    border-radius: 30px;
    font-size: 16px;
    padding-left: 20px;
    margin-left: 20px;
    border: 1px solid #cfcfcf;
    outline: none;
}

.btn {
    width: 200px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 0;
    color: #FFF;
    background-color: #33D0C2;
    font-size: 16px;
    margin-right: 30px;
    cursor: pointer;
}

.foot {
    text-align: center;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// hotel.vue?d2604266